import React from 'react';

export default () => (
<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0.916504L4.16667 5.08317L8.33333 0.916504H0Z" fill="currentColor"/>
</svg>
)
